
import { useState } from 'react';
import { Container, Row, Col } from "react-bootstrap";
import blog from '../assets/img/springsecurity.png';
import blog2 from '../assets/img/spring_boot_angular_architecture.png';
import { useTheme, DARK, LIGHT } from '../context/ThemeContext';

const blogs = [
  {
    image: blog,
    tag: 'Spring Boot · Security',
    title: 'Building Secure Spring Boot Applications with JWT Authentication',
    excerpt: 'A step-by-step guide to implementing JWT-based authentication in Spring Boot, covering token generation, validation, and securing REST endpoints with Spring Security.',
    url: 'https://medium.com/@sandhya.khinmyowai_40698/building-secure-spring-boot-applications-with-jwt-authentication-ec833ef8d24d',
    readTime: '5 min read',
    date: 'Jan 2024',
  },
  {
    image: blog2,
    tag: 'Spring Boot · Angular',
    title: 'Building REST APIs with Spring Boot and Angular: A Full-Stack Guide',
    excerpt: 'A practical end-to-end guide to designing and consuming production-ready REST APIs — covering DTOs, service layers, global exception handling, CORS configuration, and Angular HttpClient integration.',
    url: 'https://medium.com/@sandhya.khinmyowai_40698/building-rest-apis-with-spring-boot-and-angular-a-full-stack-guide-3fda914e8123?postPublishedType=repub',
    readTime: '8 min read',
    date: 'Jul 2026',
  },
  
];
 
export const Blog = () => {
  const { isDark } = useTheme();
  const t = isDark ? DARK : LIGHT;
  const [hovered, setHovered] = useState(null);
 
  return (
    <section id="blogs" style={{ background: t.bg, padding: '60px 0', transition: 'background 0.3s' }}>
      <Container>
 
   
        <div style={{ textAlign: 'center', marginBottom: '36px' }}>
          <div style={{ fontSize: '11px', fontWeight: 600, letterSpacing: '3px', textTransform: 'uppercase', color: t.accent, marginBottom: '8px' }}>
            Writing
          </div>
          <div style={{ fontSize: '26px', fontWeight: 700, color: t.text }}>Blogs</div>
        </div>
 
        <Row>
          {blogs.map((post, i) => (
            <Col key={i} sm={12} md={6} lg={4} className="mb-4">
              <a
                href={post.url}
                target="_blank"
                rel="noreferrer"
                style={{ textDecoration: 'none' }}
                onMouseEnter={() => setHovered(i)}
                onMouseLeave={() => setHovered(null)}
              >
                <div style={{
                  background: t.bgAlt,
                  border: `1px solid ${hovered === i ? t.borderHover : t.border}`,
                  borderRadius: '14px',
                  overflow: 'hidden',
                  transition: 'all 0.25s ease',
                  boxShadow: hovered === i ? t.shadow : 'none',
                  transform: hovered === i ? 'translateY(-4px)' : 'none',
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                }}>
 
                 
                  <div style={{ position: 'relative', overflow: 'hidden', height: '180px' }}>
                    <img
                      src={post.image}
                      alt={post.title}
                      style={{
                        width: '100%', height: '100%',
                        objectFit: 'cover',
                        transition: 'transform 0.4s ease',
                        transform: hovered === i ? 'scale(1.05)' : 'scale(1)',
                      }}
                    />
                 
                    <div style={{
                      position: 'absolute', inset: 0,
                      background: 'linear-gradient(to top, rgba(0,0,0,0.6) 0%, transparent 60%)',
                    }} />
                    
                    <div style={{
                      position: 'absolute', top: '12px', left: '12px',
                      background: `${t.accent}cc`,
                      color: '#fff', fontSize: '10px', fontWeight: 600,
                      letterSpacing: '0.8px', padding: '3px 10px',
                      borderRadius: '20px', textTransform: 'uppercase',
                    }}>
                      {post.tag}
                    </div>
                  </div>
 
                  
                  <div style={{ padding: '18px 20px', display: 'flex', flexDirection: 'column', flex: 1 }}>
 
                    
                    <div style={{
                      display: 'flex', alignItems: 'center', gap: '10px',
                      fontSize: '11px', color: t.textSub, marginBottom: '10px',
                    }}>
                      <span>{post.date}</span>
                      <span style={{ width: '3px', height: '3px', borderRadius: '50%', background: t.textSub }} />
                      <span>⏱ {post.readTime}</span>
                    </div>
 
                   
                    <div style={{
                      fontSize: '14px', fontWeight: 700,
                      color: t.text, lineHeight: 1.5,
                      marginBottom: '10px',
                    }}>
                      {post.title}
                    </div>
 
                  
                    <div style={{
                      fontSize: '12.5px', color: t.textSub,
                      lineHeight: 1.7, flex: 1,
                      display: '-webkit-box',
                      WebkitLineClamp: 3,
                      WebkitBoxOrient: 'vertical',
                      overflow: 'hidden',
                    }}>
                      {post.excerpt}
                    </div>
 
                   
                    <div style={{
                      marginTop: '16px',
                      paddingTop: '14px',
                      borderTop: `1px solid ${t.border}`,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                    }}>
                      <span style={{
                        fontSize: '12px', fontWeight: 600,
                        color: t.accent,
                        display: 'flex', alignItems: 'center', gap: '5px',
                      }}>
                        Read on Medium ↗
                      </span>
                      <span style={{
                        fontSize: '11px', color: t.textSub,
                        background: t.tagBg, border: `1px solid ${t.tagBorder}`,
                        padding: '2px 8px', borderRadius: '10px',
                      }}>
                        Medium
                      </span>
                    </div>
                  </div>
 
                </div>
              </a>
            </Col>
          ))}
        </Row>
 
      </Container>
    </section>
  );
};